<div class="col-card">
  <div class="col-head">
    <div class="col-icon warn"><i class="bi bi-tools"></i></div>
    <div class="col-head-text">
      <div class="col-title-row">
        <span class="col-title">Errors you can fix</span>
        <span class="col-count" *ngIf="groups.length">{{ groups.length }} reason{{ groups.length === 1 ? '' : 's' }}</span>
      </div>
      <p class="col-desc">Records Sage rejected for a reason only you can clear.</p>
    </div>
    <button class="col-link" (click)="openIssues.emit()">View all</button>
  </div>

  <div class="col-body" *ngIf="loading">
    <div class="col-empty"><i class="bi bi-arrow-repeat spin"></i><span>Loading&hellip;</span></div>
  </div>

  <div class="col-body" *ngIf="!loading && groups.length">
    <div class="group" *ngFor="let g of visibleGroups; trackBy: trackGroup">
      <div class="group-main">
        <div class="group-title-row">
          <span class="group-label">{{ g.label }}</span>
          <span class="group-count warn">{{ g.count }}</span>
        </div>
        <div class="group-sub">
          <span class="entity-tag" *ngIf="g.entityPill">{{ g.entityPill }}</span>
          <span>{{ g.whatToDo }}</span>
        </div>
        <div class="group-actions">
          <button class="btn-solid" (click)="fixGroup.emit(g)">{{ g.action || 'See what to do' }}</button>
        </div>
      </div>
    </div>

    <button class="btn-dashed" *ngIf="hiddenGroupCount && !showAllGroups" (click)="showAllGroups = true">
      Show {{ hiddenGroupCount }} more reason{{ hiddenGroupCount === 1 ? '' : 's' }}
    </button>
    <button class="btn-dashed" *ngIf="showAllGroups && hiddenGroupCount" (click)="showAllGroups = false">
      Show fewer
    </button>
  </div>

  <div class="col-body" *ngIf="!loading && !groups.length">
    <div class="col-empty">
      <i class="bi bi-check-circle"></i>
      <span>No errors need your attention</span>
    </div>
  </div>

  <div class="col-foot">
    <i class="bi bi-arrow-repeat"></i>
    <span *ngIf="retryingCount">
      <b>{{ retryingCount }}</b> other error{{ retryingCount === 1 ? '' : 's' }} should clear on the next sync
    </span>
    <span *ngIf="!retryingCount">Nothing waiting to retry</span>
    <button class="col-link" *ngIf="retryingCount" (click)="openIssues.emit()">View in Issues</button>
  </div>
</div>
